import { hotItems } from '@/mocks/chiguaData';

const rankColor = (i: number) => {
  if (i === 0) return 'bg-primary-500 text-background-50';
  if (i === 1) return 'bg-secondary-500 text-background-50';
  if (i === 2) return 'bg-accent-500 text-background-50';
  return 'bg-background-100 text-foreground-500';
};

export default function HotList() {
  return (
    <section id="hot" className="bg-background-50 py-16 md:py-24 scroll-mt-20">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10">
          {/* 左侧说明区 */}
          <div className="lg:col-span-5 flex flex-col justify-center lg:pr-4">
            <div className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
              <i className="ri-fire-fill text-lg text-primary-500"></i>今日热榜
            </div>
            <h2 className="mt-3 font-heading text-3xl md:text-[42px] font-black leading-snug text-foreground-950">
              大家都在看
              <span className="text-primary-500">什么</span>
            </h2>
            <p className="mt-4 max-w-md text-foreground-600 text-base leading-relaxed">
              热度不等人，爆点常换新。我们把实时变化最高的内容排在最前，跟着榜单走，不落任何一个热点。
            </p>
            <div className="mt-6 flex items-center gap-4">
              {[
                { label: '实时话题', value: '28' },
                { label: '累计热度', value: '1.2M' },
                { label: '今日新增', value: '17' },
              ].map((s) => (
                <div key={s.label}>
                  <div className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{s.value}</div>
                  <div className="mt-1 text-xs text-foreground-500">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* 右侧榜单 */}
          <div className="lg:col-span-7 rounded-3xl bg-background-100/70 border border-background-200 p-5 md:p-6">
            <div className="flex items-center justify-between px-2 pb-3">
              <span className="text-sm font-semibold text-foreground-700">吃瓜网站 · 热度实时榜单</span>
              <span className="text-xs text-foreground-400 flex items-center gap-1">
                <i className="ri-time-line"></i>每 5 分钟更新
              </span>
            </div>
            <ul className="flex flex-col gap-2">
              {hotItems.map((item, i) => (
                <li key={item.rank}>
                  <button
                    className="group w-full flex items-center gap-3 md:gap-4 rounded-2xl bg-background-50 px-3 py-3 md:px-4 md:py-3.5 text-left hover:bg-primary-50 transition-colors cursor-pointer"
                  >
                    <span
                      className={`w-8 h-8 md:w-9 md:h-9 shrink-0 rounded-xl flex items-center justify-center font-heading text-sm md:text-base font-bold ${rankColor(i)}`}
                    >
                      {i + 1}
                    </span>
                    <span className="flex-1 min-w-0">
                      <span className="block truncate text-sm md:text-[15px] font-medium text-foreground-900 group-hover:text-primary-700">
                        {item.title}
                      </span>
                      <span className="mt-1 block text-xs text-foreground-500">
                        <i className="ri-flashlight-line text-accent-500"></i> {item.tag}
                      </span>
                    </span>
                    <span className="flex flex-col items-end gap-1 shrink-0">
                      <span className="font-heading text-lg md:text-xl font-bold text-primary-600">{item.score}</span>
                      <span className="text-xs text-foreground-500 flex items-center gap-1">
                        <i className="ri-arrow-up-line text-accent-500"></i>热度
                      </span>
                    </span>
                    <i className="ri-arrow-right-s-line text-2xl text-background-300 group-hover:text-primary-400 transition-colors"></i>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}